import { useSessionStorage } from 'hooks/useSessionStorage';
import { useEffect, useState } from 'react';
import { verifyIsCompanyPermited } from 'utils/checkFunctionalityPermission';

export const useResult = () => {
	const { getSessionStorage } = useSessionStorage();
	const [isCompanyPermited, setIsCompanyPermited] = useState<
		boolean | undefined
	>(false);

	const getMeInfo = async () => {
		try {
			const meCompany = getSessionStorage('me');
			if (meCompany) {
				setIsCompanyPermited(
					verifyIsCompanyPermited(JSON.parse(meCompany).company, 'campaigns'),
				);
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		getMeInfo();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { isCompanyPermited };
};
